export default "__VITE_ASSET__BNMBSjsy__"